import axios from 'axios';
import utils from './oidcRoot'
import saasApi from './saasApi'

//创建一个axios实例
const instance = axios.create() // axios.create({baseURL: process.env.FILE_SERVICE}) 两种图片请求接口的网关不一样
const file = process.env.FILE_SERVICE;    //图片上传api网关

const storageFile = process.env.CLOUD_SERVICE;    // 后端下载
let token = localStorage.getItem('accessToken')
// let token = 'eyJhbGciOiJSUzI1NiIsImtpZCI6ImJlMjI3YmNiYWU2NGU3OWRiZTQzMTNiMDljMTMzYjAxIiwidHlwIjoiSldUIn0.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.QJUiUkNwNhSlfayIvsgaDDKQCD9Rxi3kk-MYlPNCFpBjIK8YQwGxdX0CgbhygeZzItBANmd68LOut_4-SbNDbKUmBHsHK0NIbqcI9gLd8mF0VXkTKxK2B4YxlWzYfaWoSdZJH0EjmY4GK4Q5MP3XY-Y_Y3Dd0J-yT1r_6WJ7DyXLURECmwQZU6aJ9LIZUULfaecXF4LfUDDRnnzBtyHhcwgfzAuARxdMS2sTUMgVq1CgLkBPLxiqwiTkz7cMekdm_1_U87kkr8cX0A1JdwapW_YB9bxLf3S6-5JphBEoRPlefUCOTPXMjQ0drUAHTw5jNMhY4bcLf8mXgYSujd913A'
//request拦截器
instance.interceptors.request.use(config => {
    //每次发送请求之前检测都vuex存有token,那么都要放在请求头发送给服务器
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config;
  },
  err => {
    //console.log(err)
    return Promise.reject(err);
  }
);
//respone拦截器
instance.interceptors.response.use(
  response => {
    return response;
  },
  error => { //默认除了2XX之外的都是错误的，就会走这里
    console.log(`err: ${error}`) //for debugger
    if (error.response) {
      switch (error.response.status) {
        case 401:
          utils.login()
          break
        case 404:
          utils.login404()
          break
        case 500:
          console.log('error 500')
          break
      }
    }
    // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
    return Promise.reject(error.response);
  }
);

//获取
export function fileUpload(params) {
  var data = new FormData();
  data.append("action", "UploadVMKImagePath");
  data.append("file", params); //加入文件对象
  return instance.post(file + saasApi.UploadFiles, data, {
      processData: false, //用于对data参数进行序列化处理 这里必须false
      contentType: false, //必须
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      }
    }).then((response) => {
      return Promise.resolve(response.data)
    })
    .catch(function (error) {
      console.log(error)
    })
}
//下载图片
export function DownLoadImg(url) {
  return instance.get(file +'/Tenant/' + url, {
      responseType: 'blob',
    })
    .then((response) => {
      return Promise.resolve(response.data)
    })
    .catch(function (error) {
      console.log(error)
    })
}
//get请求图片
export default {
  instance,
  getImg(url,data) {        //get请求图片
    if (url.indexOf('http') == -1) url = storageFile + url;
    return instance({
      method: 'get',
      url,
      // timeout: 60000,
      responseType: "blob",
    });
  }
}



// WEBPACK FOOTER //
// ./src/public/fileUpload.js